import { useMutation, useQueryClient } from 'react-query'

import request from '../../config/axios'
import QueryKeys from './QueryKeys'
import { Staff } from './useCurrentUser'
import { Site } from './useSitesAvailable'

interface JoinClinicResponse {
  staff: Staff
}

export interface JoinClinicVars {
  staffId: string
  site: Site
  staff: Staff
}

const useJoinClinicSite = () => {
  const queryClient = useQueryClient()

  return useMutation(({ staffId, site, staff: _staff }: JoinClinicVars) => {
    const url = `/impacts/staffs/${staffId}?join_existing=true`

    return request
      .patch<JoinClinicResponse>(url, {
        site_ids: [site.id], // Backend only reads this parameter for join_existing flow
      })
      .then((r) => {
        queryClient.invalidateQueries(QueryKeys.staffs(site.id))
        queryClient.invalidateQueries(QueryKeys.sitesAvailable())
        queryClient.invalidateQueries(QueryKeys.productsAvailable())
        queryClient.invalidateQueries(QueryKeys.currentUser())
        return r.data.staff
      })
  })
}

export default useJoinClinicSite
